<template>
    <div class="BoxWide">
        <div class="Filter">
        <form>
            <fieldset>
            <legend>Filtra per:</legend>
            <div class="FormRow">
                <div class="FormBox25">
                    <label>Stato</label>
                    <select class="CustomSelect NoSearch" name="" id="selectStatoContratti">
                        <option value="all">Tutti</option>
                        <option v-for="(stato, index) in this.$store.getters.getStatiContratto" :key="index" :value="stato.Codice">{{ stato.Descrizione }}</option>
                    </select>
                </div>
                <div class="FormBox25">
                    <label>Sito</label>
                    <select class="CustomSelect NoSearch" name="" id="SelectSiti">
                        <option value="all">Tutti</option>
                        <option v-for="(sito,index) in this.$store.getters.getSiti" :key="index" :value="sito.CodiceSito">{{ sito.DescrizioneOperativa }}</option>               
                    </select>
                </div>
                <div class="FormBox25">
                    <div class="TwinButtons">
                        <div class="Button ExtraSmall">                  
                            <input type="button" id="" name="" value="Filtra" @click="this.filtraContratti()" />
                        </div>
                        <div class="Button ExtraSmall">
                            <a href="javascript:void(0)" @click="this.rimuoviFiltri">Rimuovi filtri</a>
                        </div>
                    </div>
                </div>
            </div>
            </fieldset>
        </form>
        </div>
    </div>
</template>

<script>

    import FiltroModelliContratti from "@/models/filtroModelliContratti.model.js";


    export default {
        name: "FiltroContratti",
        data() {
            return {
                sitoSelected: "",
                statoSelected: ""
            }
        },
        methods: {
            filtraContratti: function(){
                this.sitoSelected =  $('#SelectSiti').select2('data')[0].id;   
                this.statoSelected = $('#selectStatoContratti').select2('data')[0].id;

                this.$emit("FiltraContratti", new FiltroModelliContratti( this.statoSelected, this.sitoSelected));
            },

            rimuoviFiltri: function(){
                $('#SelectSiti').val("all").trigger('change');
                $('#selectStatoContratti').val("all").trigger('change');
                this.statoSelected = "all";
                this.sitoSelected = "all";

                this.$emit("RimuoviFiltri");
            }
        },

        mounted: function(){
            $(document).ready(function() {
                $('.CustomSelect').select2({
                    theme: "classic"
                });

                $('.CustomSelect').on('select2:select', function (e) {
                    var codiceSito = e.params.data.id;
                    $("#sitoSelected").val(codiceSito);
                });

                $('.CustomSelect').on('select2:select', function (e) {
                    var codiceStato = e.params.data.id;
                    $("#statoSelected").val(codiceStato);
                });
            });
        }
        
    };
</script>
